/* eslint-disable @typescript-eslint/no-explicit-any */
import type { ActionOption, ActivityContent, ActivityItem, ActivityTabCategory } from './useActivityTransformer';
import type { WorkflowActionableType } from '@/api/entity_types/workflow/WorkflowDefinition';
import RailsUtility from '@/utilities/rails';

export const useTransformWorkflowScheduledAction = () => {
  const getEmailContent = (typeable: { subject: string; body: string }): ActivityContent[] => {
    return [
      { label: 'Subject', richText: typeable.subject ?? 'No subject available' },
      { richText: typeable.body ?? 'No email body available' },
    ];
  };

  const getSmsContent = (typeable: { body: string }): ActivityContent[] => {
    return [{ richText: typeable.body ?? 'No message body available' }];
  };

  const getTaskContent = (typeable: {
    due_date: string;
    assignee: string;
    title: string;
    body: string;
  }): ActivityContent[] => {
    return [
      { label: 'Due', richText: typeable.due_date ?? 'No due date' },
      { label: 'Assignee', richText: typeable.assignee ?? 'No assignee' },
      { label: 'Title', richText: typeable.title ?? 'No title' },
      { richText: typeable.body },
    ];
  };

  const transformWorkflowScheduledAction = (scheduledAction: any): ActivityItem => {
    const actionType = scheduledAction.type as WorkflowActionableType;
    const labels: Record<WorkflowActionableType, string> = {
      WorkflowActionEmail: 'Workflow Email',
      WorkflowActionSms: 'Workflow SMS',
      WorkflowActionOneOffTask: 'Workflow One-Off Task',
    };

    const categories: Record<WorkflowActionableType, ActivityTabCategory[]> = {
      WorkflowActionEmail: ['emails'],
      WorkflowActionSms: ['messages'],
      WorkflowActionOneOffTask: ['notes'],
    };

    const content: ActivityContent[] = [
      { label: 'Status', richText: RailsUtility.convertFromCasedEnumFormat(scheduledAction.status) },
    ];
    if (labels[actionType] === 'Workflow Email') {
      content.push(...getEmailContent(scheduledAction.typeable));
    } else if (labels[actionType] === 'Workflow SMS') {
      content.push(...getSmsContent(scheduledAction.typeable));
    } else if (labels[actionType] === 'Workflow One-Off Task') {
      content.push(...getTaskContent(scheduledAction.typeable));
    }

    const buttons: ActionOption[] = [];

    if (scheduledAction.status === 'pending') {
      buttons.push({ title: 'Cancel', action: { emitId: 'cancel-workflow-clicked' } });
    }

    return {
      id: scheduledAction.instance_id,
      categories: categories[actionType],
      icon: 'workflow',
      verb: 'scheduled an automation',
      typeLabel: 'Workflow scheduled action',
      displayTimestamp: scheduledAction.invoke_on,
      sortTimestamp: scheduledAction.invoke_on,
      actor: 'Workflow automation',
      label: labels[actionType],
      content,
      buttons,
    };
  };

  return { transformWorkflowScheduledAction };
};
